import styled from "styled-components";

export const SectionWrap = styled.div`
    padding-block: 60px;
`;
